import styled from 'styled-components';
import { IdealMembersInputContainer } from '../../NameGenerator/IdealMembersInput/IdealMembersInputWithButton.styles';
import { layout } from 'app_previous/styles/layout';

export const InlineGeneratorInputContainer = styled.div`
  display: grid;
  width: 100%;
  grid-row-gap: 1rem;
  margin: 0 auto;

  > button {
    width: 100%;
    max-width: 450px;
    margin: 0.8rem auto 0;
  }

  ${IdealMembersInputContainer} {
    margin: 0 auto;
  }

  @media (max-width: ${layout.md}) {
    grid-row-gap: 0.5rem;

    > button {
      margin-top: 0;
    }
  }
`;
